import { Component, OnInit, OnDestroy } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import * as numeral from 'numeral';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { EmitterService } from '../../../../core/utility/services/emitter.service';

@Component({
	selector: 'app-placements',
	templateUrl: './placements.component.html',
	styleUrls: ['./placements.component.css']
})
export class PlacementsComponent implements OnInit, WidgetCore, OnDestroy {
	placementsData: any[] = [];
	showLoad = true;
	reorderable = false;

	public key: string;
	public sectiontitle: string;

	columns = [
		{ name: 'Domain', prop: 'place', headerClass: 'domainHeader', cellClass: 'domain', resizeable: false },
		{
			name: 'Impressions',
			prop: 'formatted_impressions',
			headerClass: 'impressionsHeader',
			cellClass: 'impressions',
			comparator: this.impressionsComparator.bind(this),
			resizeable: false
		},
		{
			name: 'Clicks',
			prop: 'formatted_clicks',
			headerClass: 'clicksHeader',
			cellClass: 'clicks',
			comparator: this.clicksComparator.bind(this),
			resizeable: false
		},
		{
			name: 'Click Rate',
			prop: 'formatted_click_rate',
			headerClass: 'clickRateHeader',
			cellClass: 'clickRate',
			comparator: this.clickRateComparator.bind(this),
			resizeable: false
		}
	];
	public reloadSubscription;
	public widgetDataSubscription;

	constructor(private analyticsService: AnalyticsService) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			this.requestData();
		});
	}

	ngOnInit() {
		this.requestData();
	}

	ngOnDestroy() {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData() {
		this.showLoad = true;
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((res: any) => {
			this.placementsData = [];
			this.showLoad = false;
			if (res.success) {
				this.processResponseData(res.data);
			} else {
				this.placementsData = [];
			}
		});
	}

	processResponseData(responseData: any) {
		for (let i = 0; i < responseData.length; i++) {
			let clickRate;
			clickRate = responseData[i].click_rate;
			if (clickRate != null) {
				clickRate = parseFloat(clickRate).toFixed(2);
			} else {
				clickRate = 0;
			}
			const obj = {
				place: responseData[i].place,
				impressions: parseInt(responseData[i].impressions),
				formatted_impressions: numeral(responseData[i].impressions).format('0,0'),
				clicks: parseInt(responseData[i].clicks),
				formatted_clicks: numeral(responseData[i].clicks).format('0,0'),
				click_rate: clickRate,
				formatted_click_rate: clickRate + '%'
			};
			this.placementsData.push(obj);
		}
	}

	/**
	 *  Sorts Descending
	 * @param a
	 * @param b
	 * @param c
	 * @param d
	 * @returns {number}
	 */
	impressionsComparator(a, b, c, d) {
		if (c.impressions < d.impressions) {
			return 1;
		}
		if (c.impressions > d.impressions) {
			return -1;
		}
	}

	clicksComparator(a, b, c, d) {
		if (c.clicks < d.clicks) {
			return 1;
		}
		if (c.clicks > d.clicks) {
			return -1;
		}
	}

	clickRateComparator(a, b, c, d) {
		if (parseFloat(c.click_rate) < parseFloat(d.click_rate)) {
			return 1;
		}
		if (parseFloat(c.click_rate) > parseFloat(d.click_rate)) {
			return -1;
		}
	}

	downloadDataInCSV(event: any) {
		event.preventDefault();
		this.analyticsService.downloadCSV(this.key, 'placements');
	}
}
